import script from "./selectaccid.vue?vue&type=script&setup=true&lang=js"
export * from "./selectaccid.vue?vue&type=script&setup=true&lang=js"

import "./selectaccid.vue?vue&type=style&index=0&id=066250f0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-066250f0"]])

export default __exports__